import { Component, Input } from '@angular/core';
import { Rehearsal } from '../rehearsal';

@Component({
    selector: 'app-rehearsal-details-list',
    templateUrl: './rehearsal-details-list.component.html',
    styleUrls: ['./rehearsal-details-list.component.scss'],
    standalone: false
})
export class RehearsalDetailsListComponent {

  @Input() public rehearsal: Rehearsal | null = null;

}
